import {
  RULES_FETCH_REQUEST,
  RULES_FETCH_SUCCESS,
  RULES_FETCH_FAILURE,
  RULE_SAVE_REQUEST,
  RULE_SAVE_SUCCESS,
  RULE_SAVE_FAILURE,
  RULE_DELETE_SUCCESS,
  RULE_TOGGLE_SUCCESS,
  RULES_REORDER_SUCCESS,
  RULES_STORES_FETCH_REQUEST,
  RULES_STORES_FETCH_SUCCESS,
  RULES_STORES_FETCH_FAILURE,
} from '../constants';

const initialState = {
  items: [],
  loading: false,
  saving: false,
  error: null,
  saveErrors: null,
  stores: [],
  storesLoading: false,
  storesError: null,
};

export default function rulesReducer(state = initialState, action) {
  switch (action.type) {
    case RULES_FETCH_REQUEST:
      return { ...state, loading: true, error: null };

    case RULES_FETCH_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };

    case RULES_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case RULE_SAVE_REQUEST:
      return { ...state, saving: true, saveErrors: null };

    case RULE_SAVE_SUCCESS: {
      const rule = action.payload;
      const existing = state.items.findIndex((r) => r.id === rule.id);
      const items =
        existing >= 0
          ? state.items.map((r) => (r.id === rule.id ? rule : r))
          : [...state.items, rule];
      return { ...state, saving: false, items, saveErrors: null };
    }

    case RULE_SAVE_FAILURE:
      return { ...state, saving: false, saveErrors: action.payload };

    case RULE_DELETE_SUCCESS:
      return { ...state, items: state.items.filter((r) => r.id !== action.payload) };

    case RULE_TOGGLE_SUCCESS:
      return {
        ...state,
        items: state.items.map((r) =>
          r.id === action.payload.ruleId ? { ...r, enabled: action.payload.enabled } : r
        ),
      };

    case RULES_REORDER_SUCCESS: {
      const orderMap = {};
      action.payload.forEach((id, idx) => {
        orderMap[id] = idx + 1; // 1-based priority
      });
      const reordered = [...state.items].sort(
        (a, b) => (orderMap[a.id] || 999) - (orderMap[b.id] || 999)
      );
      return {
        ...state,
        items: reordered.map((r, i) => ({ ...r, priority: i + 1 })),
      };
    }

    case RULES_STORES_FETCH_REQUEST:
      return { ...state, storesLoading: true, storesError: null };

    case RULES_STORES_FETCH_SUCCESS:
      return {
        ...state,
        storesLoading: false,
        stores: Array.isArray(action.payload) ? action.payload : [],
        storesError: null,
      };

    case RULES_STORES_FETCH_FAILURE:
      return { ...state, storesLoading: false, storesError: action.payload };

    default:
      return state;
  }
}
